<div class="contact-self-service-wrapper" *ngIf="form; else spinner"
  [style.backgroundImage]="settings.background ? 'url(data:image/jpeg;base64,'+ settings.background +')' : null">
  <div class="form-container">
    <div [ngClass]="settings.logoPosition">
      <img *ngIf="settings.logoBase64" [src]="settings.logoBase64" alt="Logo" class="logo">
    </div>
    <h1 class="header">{{ 'MAIN.TITLE' | translate }}</h1>
    <div class="content">
      <p
      [innerHtml]="(settings?.defaultContent.length > 0 ? settings?.defaultContent : settings?.headerContent) | safehtml">
    </p>
    <p class="formName" [title]="formName">{{formName}}</p>
    </div>
    <div class="panel">
      <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
        <mat-tab-group [(selectedIndex)]="selectedIndex">
          <mat-tab *ngFor="let tab of tabs; let tabIndex = index;" [label]="tab.tabName">
            <formly-form [form]="formGroup" [model]="model" [fields]="tab.fields" [options]="options[tabIndex]">
            </formly-form>
          </mat-tab>
        </mat-tab-group>
        <div class="buttons">
          <button *ngIf="(tabs?.length - 1) !== selectedIndex" mat-raised-button class="btn btn-primary"
            mat-raised-button color="primary" type="button" (click)="moveToNextTab()">
            {{ 'BUTTON.NEXT' | translate }}
          </button>
          <button *ngIf="(tabs?.length - 1) === selectedIndex" mat-raised-button class="btn btn-primary"
            [disabled]="submitInProgress || formGroup.invalid" mat-raised-button color="primary" type="submit">{{
            'BUTTON.SUBMIT' | translate }}</button>
        </div>
        <div class="content">
          <p [innerHtml]="settings?.footerContent | safehtml"></p>
        </div>
        <app-footer customFooterClass="landing-email-screen"></app-footer>
      </form>
    </div>
  </div>
</div>

<ng-template #spinner>
  <div class="spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>
